// project imports
import { Grid, Chip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useState, useEffect } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import { get, put } from '../../../axios/apiService';
import LoadingBackdrop from 'ui-component/full-screen-loadder/LoadingBackdrop';
import CustomNoRowsOverlay from 'ui-component/customNoRowsOverlay';
import SearchIcon from '@mui/icons-material/Search';
import { Modules } from 'store/constant';
import SearchBar from 'ui-component/SearchBar/SearchBar';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #11111111',
  boxShadow: 24,
  p: 4
};

const Subscriber = () => {
  const [isLoading, setLoading] = useState(false);
  const [emails, setEmails] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [permissionMatrix, setPermissionMatrix] = useState({});
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
  const [sortModel, setSortModel] = useState([]);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);

  // ============= FETCH emails =============
  useEffect(() => {
    const fetchemails = async () => {
      setLoading(true);

      try {
        const encoded = encodeURIComponent(search);
        const filterQuery = search
          ? `&$filter=Email~LIKE~${encoded} OR FirstName~LIKE~${encoded} OR LastName~LIKE~${encoded}`
          : '';

        const skip = paginationModel.page * paginationModel.pageSize;
        const top = paginationModel.pageSize;

        const url = `EmailSubscribeSync?$skip=${skip}&$top=${top}${filterQuery}`;

        const response = await get(url, null);

        if (response && response.values) {
          setEmails(response.values);
          setRowCount(response.totalCount);
        } else {
          setEmails([]);
          setRowCount(0);
        }
      } catch (err) {
        console.error('Failed to load emails', err);
      } finally {
        setLoading(false);
      }
    };

    fetchemails();
  }, [paginationModel, sortModel, search]);



  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleSortModelChange = (model) => {
    setSortModel(model);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleClose = () => {
    setOpen(false);
    setDeleteId('');
  };

  // ============= COLUMNS =============
  const columns = [
    { field: 'email', headerName: 'Email', flex: 1 },
    { field: 'firstName', headerName: 'First Name', flex: 1 },
    { field: 'lastName', headerName: 'Last Name', flex: 1 },
      ];

  return (
    <>
      <MainCard title="Subscribers">
        <Grid container spacing={3}>
          {/* SEARCH + ADD BUTTON */}
          <Grid item xs={12}>
            <SearchBar
              value={search}
              onChange={handleSearchChange}
            />
          </Grid>

          {/* DATA GRID */}
          <Grid item xs={12}>
            <DataGrid
              getRowId={(row) => row.email}
              rows={emails}
              rowCount={rowCount}
              columns={columns}
              paginationMode="server"
              sortingMode="server"
              pageSizeOptions={[10]}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              sortModel={sortModel}
              onSortModelChange={handleSortModelChange}
              components={{ NoRowsOverlay: CustomNoRowsOverlay }}
              columnVisibilityModel={{
                action: permissionMatrix?.writeRights
              }}
            />
          </Grid>
        </Grid>
      </MainCard>
      <LoadingBackdrop open={isLoading} />

    </>
  );
};

export default Subscriber;

// MAPPING SORT FIELDS
const sortAccountField = (field) => {
  if (field === 'email') return 'Email';
  if (field === 'firstName') return 'FirstName';
  if (field === 'lastName') return 'LastName';
  if (field === 'accountUid') return 'AccountUid';
  if (field === 'emailstageLabel') return 'emailstageLabel';
  if (field === 'startDate') return 'StartDate';
  if (field === 'renewalDate') return 'RenewalDate';
  if (field === 'verificationStatus') return 'VerificationStatus';
  return '';
};

